import { createAction, createActionGroup, props } from '@ngrx/store';
import { InitialPortalApplicantRequestDto } from '@shared/models/initial-request-dto';
import { Pageable, Sort } from '@shared/models/page-sort/pageable';
import {
    ApplicantRequestDto,
    ConfirmatoryPortalApplicantRequestDto,
    DraftConfirmatoryPortalDto
} from '@shared/models/applicant-request-dto';
import { CaseDetailsDto } from '@shared/models/caseDetails-dto';
import { CorrespondenceDto } from '@shared/models/correspondence-dto';
import { DocumentDetailsDto } from '@shared/models/document-details-dto';

export const submitInitialRequest = createAction(
    '[Initial Request Component] Submit initial applicant request',
    props<{ request: InitialPortalApplicantRequestDto, attachments: File[] }>()
);

export const loadApplicantRequests = createAction(
    '[Requests Component] Load applicant requests',
    props<{ pageable: Pageable }>()
);

export const loadApplicantRequestApiActions = createActionGroup({
    source: 'Applicant requests API',
    events: {
        applicantRequestsSuccess: props<{ requests: ApplicantRequestDto[], sort: Sort }>()
    }
});

export const sortApplicantRequests = createAction(
    '[Requests Component] Sort applicant requests',
    props<{ sort: Sort }>()
);

export const pageApplicantRequests = createAction(
    '[Requests Component] Page applicant requests',
    props<{ page: number }>()
);

export const loadCaseDetails = createAction(
    '[Requests Component] Load case details',
    props<{ caseId: number }>()
);
export const loadCaseDetailsApiActions = createActionGroup({
    source: 'Case details API',
    events: {
        caseDetailsSuccess: props<{ caseDetails: CaseDetailsDto }>()
    }
});

export const updateCaseDetailSubject = createAction(
    '[Requests Component] Update case detail subject',
    props<{ caseId: number, subject: string }>()
);

export const loadInitialCaseDetails = createAction(
    '[Requests Component] Load initial case details',
    props<{ caseId: number }>()
);

export const loadInitialCaseDetailsApiActions = createActionGroup({
    source: 'Initial case details API',
    events: {
        caseInitialRequestSuccess: props<{ initialCaseDetails: CaseDetailsDto }>()
    }
});

export const resetInitialCaseDetails = createAction(
    '[Requests Component] Reset initial case details'
);

export const withdrawRequest = createAction(
    '[Requests Component] Withdraw request',
    props<{ caseId: number }>()
);

export const loadCorrespondenceDetails = createAction(
    '[Requests Component] Load correspondence details',
    props<{ caseId: number, correspondenceId: number }>()
);
export const loadCorrespondenceDetailsApiActions = createActionGroup({
    source: 'Load correspondence details API',
    events: {
        loadCorrespondenceDetailsSuccess: props<{ correspondence: CorrespondenceDto }>()
    }
});

export const selectTab = createAction(
    '[Requests Component] Select tab',
    props<{ selectedTabId: string }>()
);

export const createDraftCorrespondence = createAction(
    '[Requests Component] Create draft correspondence',
    props<{ caseId: number, correspondenceContent: string, attachments: DocumentDetailsDto[], replyingCorrespondenceId: number }>()
);

export const updateDraftCorrespondence = createAction(
    '[Requests Component] Update draft correspondence',
    props<{ caseId: number, correspondenceContent: string, attachments: DocumentDetailsDto[], replyingCorrespondenceId: number }>()
);

export const sendDraftCorrespondence = createAction(
    '[Requests Component] Send draft correspondence',
    props<{ caseId: number, message: CorrespondenceDto, replyMessage: { content: string, attachments: DocumentDetailsDto[] } }>()
);

export const deleteDraftCorrespondence = createAction(
    '[Requests Component] Delete draft correspondence',
    props<{ caseId: number, correspondenceId: number }>()
);

export const loadDraftConfirmatoryRequest = createAction(
    '[Confirmatory Request Component] Load draft confirmatory request',
    props<{ caseId: number }>()
);
export const loadDraftConfirmatoryRequestApiActions = createActionGroup({
    source: 'Load draft confirmatory request API',
    events: {
        loadDraftConfirmatoryRequestSuccess: props<{ draftConfirmatoryRequest: DraftConfirmatoryPortalDto }>()
    }
});

export const discardDraftConfirmatoryRequest = createAction(
    '[Confirmatory Request Component] Discard draft confirmatory request',
    props<{ caseId: number }>()
);

export const createDraftConfirmatoryRequest = createAction(
    '[Confirmatory Request Component] Create draft confirmatory request',
    props<{ caseId: number, draftConfirmatoryRequest: DraftConfirmatoryPortalDto }>()
);

export const updateDraftConfirmatoryRequest = createAction(
    '[Confirmatory Request Component] Update draft confirmatory request',
    props<{ caseId: number, draftConfirmatoryRequest: DraftConfirmatoryPortalDto }>()
);

export const submitConfirmatoryRequest = createAction(
    '[Confirmatory Request Component] Submit confirmatory applicant request',
    props<{ caseId: number, request: ConfirmatoryPortalApplicantRequestDto, attachments: File[] }>()
);

